const DATA_HOOKS = {
  explanation: "file-upload-explanation",
  popoverButton: "file-upload-popover-button",
  popoverContent: "file-upload-popover-content",
  popoverFile: "file-upload-popover-file",
  popoverFileName: "file-upload-popover-file-name",
  popoverFileError: "file-upload-popover-file-error",
  singleFile: "file-upload-single-file",
  delete: "file-upload-delete",
  spinner: "file-upload-spinner"
};
export {
  DATA_HOOKS
};
//# sourceMappingURL=dataHooks.js.map
